import axios from "axios"
import config from "config"

export const ntakControl = {
  reload: async (token, providerID, feldolgozasAzonosito) => {
    if (token == null) return { success: false, data: null, errorCode: 450 }
    try {
      const response = await axios
        .create({
          timeout: 15000,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .post(`${config().apiBaseUrl}/api/ntak/rms/control`, {
          providerID,
          feldolgozasAzonosito,
        })
      return response.data
    } catch (error) {
      console.log(error)
      return { success: false, data: null }
    }
  },
}
